export const convertLeaveDayUnit = input => {
    var dayValue = parseInt((input*8)/8)
    var hourValue = parseInt((input*8)%8)
    var decimal = (input*8%8).toFixed(2).toString()
    var minuteValue = decimal.substring(decimal.indexOf("."))*60

    if (hourValue > 0 || minuteValue > 0) {
        return `${dayValue} วัน ${hourValue} ชั่วโมง ${minuteValue} นาที`
    } else {
        return `${dayValue} วัน`
    }
}